module.exports = __webpack_public_path__ + "img/fire.c4f9da2f.png";